import { useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';

const SchoolYearTermsQuery = graphql.persisted(
  "SchoolYearTermsQuery",
  graphql(`
    query SchoolYearTermsQuery($schoolYearId: ID!) {
      schoolYear(id: $schoolYearId) {
        id
        terms {
          id
          name
          slug
          position
          startsOn
          endsOn
        }
      }
    }
  `)
);

export { SchoolYearTermsQuery };

export function useSchoolYearTermsQuery(schoolYearId?: string) {
  return useQuery(SchoolYearTermsQuery, {
    variables: { schoolYearId: schoolYearId! },
    skip: !schoolYearId,
  });
}
